export default __webpack_public_path__ + "static/media/Analysts.1b0f845d.png";